/* eslint-disable no-restricted-syntax */

import { CheckForFailure } from './CheckForFailure';
import { CheckForSuccess } from './CheckForSuccess';
export class InputFieldGrader {
  static fromItem(item) {
    const checks = [];
    checks.push(new CheckForSuccess(item.solution.message, new RegExp(item.solution.pattern)));
    for (const feedback of item.feedback) {
      checks.push(new CheckForFailure(feedback.message, new RegExp(feedback.pattern)));
    }
    return new InputFieldGrader(checks);
  }
  constructor(checks) {
    this.checks = checks;
  }
  gradeAnswer(answer) {
    for (const check of this.checks) {
      const feedback = check.feedbackForAnswer(answer);
      if (feedback !== null) {
        return feedback;
      }
    }
    throw Error('No feedback found.');
  }
}